export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN_CENTRAL = 'ADMIN_CENTRAL',
  ADMIN_AC = 'ADMIN_AC',
  CPMP = 'CPMP',
  CNCMP = 'CNCMP',
  PUB_AC = 'PUB_AC',
  VALIDATEUR_AC = 'VALIDATEUR_AC',
  REDACTEUR_AC = 'REDACTEUR_AC',
  CNCMP_PER_PLANIFICATEUR = 'CNCMP-PER-PLANIFICATEUR',
  CNCMP_SPE_PLANIFICATEUR = 'CNCMP-SPE-PLANIFICATEUR',
  CPMP_PLANIFICATEUR = 'CPMP-PLANIFICATEUR',
  CNCMP_PER_RAPPORTEUR = 'CNCMP-PER-RAPPORTEUR',
  CNCMP_SPE_RAPPORTEUR = 'CNCMP-SPE-RAPPORTEUR',
  CPMP_RAPPORTEUR = 'CPMP-RAPPORTEUR',
  CNCMP_FILTRATION = 'CNCMP-FILTRATION',
  CPMP_FILTRATION = 'CPMP-FILTRATION',
  CNCMP_PER_AFFECTATION = 'CNCMP-PER-AFFECTATION',
  CNCMP_SPE_AFFECTATION = 'CNCMP-SPE-AFFECTATION',
  BACKOFFICE_USER = 'ROLE_BACKOFFICE_USER',
}

export interface UserDto {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  emailVerified: boolean;
  address: string;
  mobile: string;
  fixe: string;
  enabled: boolean;
  roles: string[];
  comIds?: number[];
  acIds?: number[];
  acPiloteId?: number;
  enable?: boolean | null;
}
export interface UserStringDto {
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  password?: string;
  address: string;
  mobile: string;
  fixe: string;
  comIds: number[];
  acIds: number[];
  acPiloteId: number;
  roles: string[];
  enable: boolean;
}

export interface UserCommiittee {
  id: number;
  nom: string;
  createdBy: string;
  createdAt: string;
}

export interface UserAC {
  id: number;
  nom: string;
  ancrage: string | null;
  contact: string | null;
  acPilote: boolean;
  createdBy: string;
  createdAt: string;
}

export interface UserString {
  id: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  address: string | null;
  mobile: string | null;
  fixe: string | null;
  emailVerified: boolean;
  coms: UserCommiittee[];
  acs: UserAC[];
  createdTimestamp: number;
  enabled: boolean;
  roles: string[];
  genericPassword: string | null;
}
